export function isEmptyString(value: string | null | undefined): value is null | undefined | '' {
  return value == null || value.trim() === '';
}

/**
 * Whether `host` belongs to `target` by dot-boundary suffix — `host` equals
 * `target` exactly, or `host` is a subdomain of `target`. Both inputs are
 * lower-cased before comparing. The dot prefix avoids accidental tail matches
 * like `nodemycompany.com` matching `mycompany.com`.
 *
 * Examples:
 *   matchesDomainSuffix('mycompany.com', 'mycompany.com')       // true
 *   matchesDomainSuffix('mail.mycompany.com', 'mycompany.com')  // true
 *   matchesDomainSuffix('nodemycompany.com', 'mycompany.com')   // false
 */
export function matchesDomainSuffix(host: string, target: string): boolean {
  if (isEmptyString(host) || isEmptyString(target)) return false;
  const hostLower = host.toLowerCase();
  const targetLower = target.toLowerCase();
  return hostLower === targetLower || hostLower.endsWith(`.${targetLower}`);
}

/**
 * Uppercase the first character of `value`, leaving the rest as-is.
 * Returns the input unchanged when it's empty.
 */
export function capitalize(value: string): string {
  if (value === '') return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}
